import { rem } from 'polished'
import React from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'

import TextButton from 'LuxKit/Button/TextButton'
import BodyText from 'LuxKit/Typography/BodyText'
import ViewMoreOffersCta from 'tripPlanner/components/Buttons/ViewMoreOffersCta'

const Wrapper = styled.div`
  margin-top: ${rem(8)};
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`

const PriceAndCta = styled(Wrapper)`
  align-items: flex-end;
  flex-direction: row-reverse;
`

const SoldOutCta = styled(Wrapper)`
  align-items: center;
`

interface Props {
  isSoldOut: boolean
  soldOutOfferId?: string
  offerPriceDetails: React.ReactElement | undefined
  tripId: string
  sectionId: string
}

function PriceAndCtaOrSoldOut({
  isSoldOut,
  soldOutOfferId,
  offerPriceDetails,
  tripId,
  sectionId,
}: Props) {
  const intl = useIntl()

  if (isSoldOut) {
    return (
      <SoldOutCta>
        <BodyText variant="large" weight="bold">
          {intl.formatMessage({
            id: 'zIAXwSL0n6uQqCImxKeJ',
            defaultMessage: 'Sold Out',
            description: 'Label indicating a saved offer is sold out in trip planner',
          })}
        </BodyText>
        <ViewMoreOffersCta
          offerId={soldOutOfferId}
          sectionId={sectionId}
          tripId={tripId}
          showSearch
        />
      </SoldOutCta>
    )
  }

  // Row-reverse to right align the button even if the price doesn't exist.
  // Button is `nonInteractable` because this component gets rendered inside a link.
  return (
    <PriceAndCta>
      <TextButton kind="primary" size="medium" nonInteractable>
        {intl.formatMessage({
          id: 'v2_0yof_duvGKTG97V8E',
          defaultMessage: 'View',
          description: 'Button label to view a saved offer in trip planner',
        })}
      </TextButton>
      {offerPriceDetails}
    </PriceAndCta>
  )
}
export default PriceAndCtaOrSoldOut
